import { AnswerResult } from "../../../store/viewmodels/AnswerViewModel";
import { getClockTime, getDate, getDurationInSeconds, getMins, getSeconds } from "../../utils/DateServices";

interface StudentMemoryGameResultProps {
    answers: AnswerResult[]
}

function StudentMemoryGameResult(props: StudentMemoryGameResultProps) {

    if (props.answers.length === 0) return <></>;

    let biggestLevel = 0;
    let allLevels: number[] = [];
    let bestEasy = undefined;
    let bestMedium = undefined;
    let bestHard = undefined;

    for (let i: number = 0; i < props.answers.length; i++) {
        let answer = props.answers[i];
        let splittedAnswer: string[] = answer.value.split(";");
        let level = Number(splittedAnswer[0]);
        let clicks = Number(splittedAnswer[1]);

        if (!allLevels.includes(level)) {
            allLevels.push(level);
        }
        if (level > biggestLevel) biggestLevel = level;

        switch (level) {
            case 4: {
                if (bestEasy === undefined) {
                    bestEasy = answer;
                } else {
                    bestEasy = SearchBest(bestEasy, answer, clicks);
                }
                break;
            }
            case 6: {
                if (bestMedium === undefined) {
                    bestMedium = answer;
                } else {
                    bestMedium = SearchBest(bestMedium, answer, clicks);
                }
                break;
            }
            case 12: {
                if (bestHard === undefined) {
                    bestHard = answer;
                } else {
                    bestHard = SearchBest(bestHard, answer, clicks);
                }
                break;
            }
        }
    }

    let easyResult = <div className="justify-center text-center my-2 text-red-500">Ei tuloksia</div>;
    let mediumResult = <div className="justify-center text-center my-2 text-red-500">Ei tuloksia</div>;
    let hardResult = <div className="justify-center text-center my-2 text-red-500">Ei tuloksia</div>;

    if (bestEasy !== undefined) {
        easyResult = GameResult(bestEasy);
    }
    if (bestMedium !== undefined) {
        mediumResult = GameResult(bestMedium);
    }
    if (bestHard !== undefined) {
        hardResult = GameResult(bestHard);
    }

    return (
        <div>
            <h1 className="m-auto text-center text-2xl text-teal-500 font-bold">Muistipeli - Parhaat tulokset</h1>
            <div className="border border-teal-200 my-2 p-2">
                <div className="flex">
                    <div className="w-1/3 px-1 mx-1">
                        <div className="flex justify-center">
                            <div className="text-xl my-auto mr-5 ">Helppo</div>
                            <div className="text-2xl md:text-3xl text-green-500 ri-game-fill my-auto"></div>
                        </div>
                        <div className="">
                            {easyResult}
                        </div>
                    </div>
                    <div className="w-1/3 px-1 mx-1">
                        <div className="flex justify-center">
                            <span className="text-xl my-auto mr-5">Keskivaikea</span>
                            <span className="text-2xl md:text-3xl text-yellow-500 ri-game-fill"></span>
                            <span className="text-2xl md:text-3xl text-yellow-500 ri-game-fill"></span>
                        </div>
                        <div>
                            {mediumResult}
                        </div>
                    </div>
                    <div className="w-1/3 px-1 mx-1">
                        <div className="flex justify-center">
                            <span className="text-xl my-auto mr-5">Vaikea</span>
                            <span className="text-2xl md:text-3xl text-red-500 ri-game-fill"></span>
                            <span className="text-2xl md:text-3xl text-red-500 ri-game-fill"></span>
                            <span className="text-2xl md:text-3xl text-red-500 ri-game-fill"></span>
                        </div>
                        <div>
                            {hardResult}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SearchBest(best: AnswerResult, answer: AnswerResult, clicks: number): AnswerResult {
    let newBest = best;

    let bestSplittedAnswer = best.value.split(";");
    let bestClicks = Number(bestSplittedAnswer[1]);
    if (clicks < bestClicks) {
        newBest = answer;
    } else if (clicks === bestClicks) {
        let start_time = new Date(Date.parse(answer.start_time));
        let end_time = new Date(Date.parse(answer.end_time));
        let allSecs = getDurationInSeconds(end_time, start_time);
        let bestStart = new Date(Date.parse(best.start_time));
        let bestEnd = new Date(Date.parse(best.end_time));
        let bestAllSecs = getDurationInSeconds(bestEnd, bestStart);

        if (allSecs < bestAllSecs) {
            newBest = answer;
        }
    }
    return newBest;
}

function GameResult(answer: AnswerResult): JSX.Element {
    const gameName = answer.item.name;
    const bestSplittedAnswer = answer.value.split(";");
    const bestClicks = Number(bestSplittedAnswer[1]);
    const start = new Date(Date.parse(answer.start_time));
    const end = new Date(Date.parse(answer.end_time));
    const duration = getDurationInSeconds(end, start);
    const mins = getMins(duration);
    const secs = getSeconds(duration);
    const date = getDate(end);
    const clockTime = getClockTime(end);
    const timeText = date + ' ' + clockTime;

    return (
        <div className="text-center">
            <div className="py-1">
                <span className="font-bold">{gameName}</span>
            </div>
            <div>{timeText}</div>
            <div>{"Klikkauksia: " + bestClicks}</div>
            <div>{"Aika: " + mins + " min " + secs + " s "}</div>
        </div>
    );
}

export default StudentMemoryGameResult;

